import { AddIcon } from '@chakra-ui/icons';
import { HStack } from '@chakra-ui/react';
import { useCallback, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import useGetLocations from './queries/useGetLocations';

import { Button } from '@/components/v4';
import AGGridMain from 'components/tables/AGGrid/AGGridMain';
import useColumnState from 'hooks/useColumnState';

import { getLocationsTableColumns } from './locationsTableConfig';

export default function LocationsList() {
    const gridRef = useRef();
    const navigate = useNavigate();

    const { darkMode } = useSelector((state) => state.settings);

    const [tableData, setTableData] = useState({
        columns: [],
        data: [],
    });

    const handleEditLocation = useCallback(
        (locationData) => {
            navigate(
                `/regions-and-locations/locations/edit/${locationData.id}`,
            );
        },
        [navigate],
    );

    const handleAddLocation = () => {
        navigate('/regions-and-locations/locations/add');
    };

    const baseColumns = useMemo(
        () =>
            getLocationsTableColumns({
                darkMode,
                onEditLocation: handleEditLocation,
            }),
        [darkMode, handleEditLocation],
    );

    const { columns, onColumnVisible } = useColumnState(baseColumns);

    const tableDataWithColumns = useMemo(
        () => ({
            columns,
            data: tableData.data,
        }),
        [columns, tableData.data],
    );

    const { refetch, isRefetching, isFetching } = useGetLocations(
        setTableData,
        gridRef,
        baseColumns,
    );

    const isFetchingData = isRefetching || isFetching;

    return (
        <AGGridMain
            gridRef={gridRef}
            tableData={tableDataWithColumns}
            isLoading={isFetchingData}
            titleName="Locations"
            refetch={refetch}
            onColumnVisible={onColumnVisible}
            overlayNoRowsTemplate="No Locations Found"
            extraComponents={
                <HStack pl={5} spacing={2}>
                    <Button
                        leftIcon={<AddIcon />}
                        onClick={handleAddLocation}
                        size="sm"
                        padding="6px 12px">
                        Add Location
                    </Button>
                </HStack>
            }
        />
    );
}
